(function () {
  'use strict';

  // An optional category shortcut; search ownership and results stay untouched.
  if (window.__adPurchaseIntentReady) return;
  if (!/^\/(?:a\/)?search\/?$/.test(window.location.pathname)) return;
  window.__adPurchaseIntentReady = true;

  var intents = [
    { id: 'penis-sleeves', query: /^penis sleeves?$/, href: '/collections/penis-sleeves', label: 'Shop penis sleeves and extenders' },
    { id: 'cock-sleeves', query: /^cock sleeves?$/, href: '/collections/penis-sleeves', label: 'Shop penis sleeves and extenders' },
    { id: 'water-based', query: /^water[ -]?based (?:lubes?|lubricants?)$/, href: '/collections/water-based-lubricants', label: 'Shop water-based lubricants' },
    { id: 'silicone-based', query: /^silicone(?:[ -]?based)? (?:lubes?|lubricants?)$/, href: '/collections/silicone-based-lubricants', label: 'Shop silicone-based lubricants' },
    { id: 'hybrid', query: /^hybrid (?:lubes?|lubricants?)$/, href: '/collections/hybrid-lubricants', label: 'Shop hybrid lubricants' },
    { id: 'anal', query: /^anal (?:lubes?|lubricants?)$/, href: '/collections/anal-lubricants', label: 'Shop anal lubricants' }
  ];
  var selector = '[data-ad-purchase-intent]';
  var observer = null;
  var observedMain = null;
  var observedParent = null;
  var frame = null;

  function queryIntent() {
    var url = new URL(window.location.href);
    if (!/^\/(?:a\/)?search\/?$/.test(url.pathname)) return null;
    var queries = url.searchParams.getAll('q');
    if (queries.length !== 1) return null;
    var types = url.searchParams.getAll('type');
    if (types.length > 1 || (types[0] && types[0] !== 'product')) return null;
    var query = queries[0].trim().toLowerCase()
      .replace(/[\u2010\u2011]/g, '-')
      .replace(/\s+/g, ' ');
    return intents.find(function (intent) { return intent.query.test(query); }) || null;
  }

  function schedule() {
    if (frame !== null) return;
    frame = window.requestAnimationFrame(function () {
      frame = null;
      sync();
    });
  }

  function observe(main, parent) {
    if (main === observedMain && parent === observedParent) return;
    if (observer) observer.disconnect();
    observedMain = main;
    observedParent = parent;
    if (!main || !('MutationObserver' in window)) return;
    if (!observer) observer = new MutationObserver(schedule);
    // Only section-level child replacement, never product-card subtree churn.
    observer.observe(main, { childList: true });
    if (parent && parent !== main) observer.observe(parent, { childList: true });
  }

  function sync() {
    var main = document.getElementById('MainContent');
    var onSearch = /^\/(?:a\/)?search\/?$/.test(window.location.pathname);
    var form = main && main.querySelector('.ad-search-results__form-wrap');
    var parent = form ? form.parentElement : main && observedParent && main.contains(observedParent) ? observedParent : null;
    observe(onSearch ? main : null, onSearch ? parent : null);
    var existing = document.querySelectorAll(selector);

    var intent = queryIntent();
    if (!intent || !form) {
      existing.forEach(function (node) { node.remove(); });
      return;
    }

    var shortcut = existing[0];
    existing.forEach(function (node, index) { if (index > 0) node.remove(); });
    if (!shortcut) {
      shortcut = document.createElement('div');
      shortcut.className = 'container ad-purchase-intent';
      var link = document.createElement('a');
      link.className = 'ad-purchase-intent__link';
      shortcut.appendChild(link);
    }
    var action = shortcut.querySelector('.ad-purchase-intent__link');
    if (!action) { shortcut.remove(); schedule(); return; }
    if (shortcut.getAttribute('data-ad-purchase-intent') !== intent.id || action.getAttribute('href') !== intent.href) {
      shortcut.setAttribute('data-ad-purchase-intent', intent.id);
      action.href = intent.href;
      action.textContent = intent.label;
      if (intent.id !== 'penis-sleeves' && intent.id !== 'cock-sleeves') {
        var arrow = document.createElement('span');
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = ' →';
        action.appendChild(arrow);
      }
    }
    if (form.nextElementSibling !== shortcut) form.insertAdjacentElement('afterend', shortcut);
  }

  function start() {
    sync();
    window.addEventListener('pageshow', schedule);
    window.addEventListener('popstate', schedule);
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('shopify:section:unload', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}());
